import { Action } from 'redux';
import { combineEpics, Epic, ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  ResourceOptionsLoadedAction,
  ResourceOptionsV2,
  UnauthorizedRequestAction,
  unauthorizedRequestAction,
} from 'medialoopster/rest';

import { URL_ANNOTATIONS } from '../../constants';
import { annotationOptionsLoaded } from './actions';
import { AnnotationOptionsLoaded, FETCH_ANNOTATION_OPTIONS } from './types';

export const annotationOptionsEpic: Epic<
  Action,
  ResourceOptionsLoadedAction | UnauthorizedRequestAction | AnnotationOptionsLoaded
> = (action$) =>
  action$.pipe(
    ofType(FETCH_ANNOTATION_OPTIONS),
    mergeMap(() =>
      ajax<ResourceOptionsV2>({
        method: 'OPTIONS',
        url: URL_ANNOTATIONS,
      }).pipe(
        map((response) => annotationOptionsLoaded(response.response.actions || {})),
        catchError((err) => {
          if (err && err.status === 401) {
            return of(unauthorizedRequestAction());
          }
          return EMPTY;
        }),
      ),
    ),
  );

export default combineEpics(annotationOptionsEpic);
